import { vuwer } from "@@assets/scripts/common";
import "@@components/topicList";
import topicsData from "../topics/__topicsData";

vuwer.add("topicList", {
	vuwType: "topicList",
	selector: "#topic_list",
	onReady($self) {
		if(!$self) {
			return false;
		}

		return this.renderList();
	}
}, function() {
	this.setData(topicsData, 3);
});
